import { MolhamTargetableMetadata } from "apiTypes";
import useMobile from "customHooks/useMobile";
import useFormattedDate from "../../../customHooks/useFormattedDate";
type Props = {
  details: MolhamTargetableMetadata[];
};
const OverViewTab = ({ details }: Props) => {
  const { formatDate } = useFormattedDate(true);
  const isEven = details.length % 2 === 0;
  const isMobile = useMobile("md");

  return (
    <>
      <div className="row w-100 px-0 px-md-0 gx-0 gx-md-0 list-group list-group-flush flex-row my-3">
        {details?.map((item, idx) => {
          const isLast = idx === details.length - 1;
          const isLastOneOrTwo = isEven
            ? idx === details.length - 2 || idx === details.length - 1
            : isLast;
          return (
            <div key={item.value} className="col-md-6">
              <div
                className={`font-size-sm fs-md me-0 py-3 my-0 list-group-item border-top-0 border-start-0 border-end-0 ${
                  idx % 2 === 1 ? "ms-md-4 ms-0 " : ""
                } ${
                  (isMobile ? isLast : isLastOneOrTwo)
                    ? "border-bottom-0"
                    : "border-bottom"
                }`}
              >
                <span className="me-1 fw-semibold"> {item.label}</span> :{" "}
                <span
                  className={`ms-1 ${
                    item.type === "integer" ? "text-primary fw-bold" : ""
                  } ${
                    item.name === "status"
                      ? "bg-faded-info fs-xs fw-medium py-1 px-2 rounded-1 my-1"
                      : ""
                  }`}
                >
                  {item.type === "datetime" ? (
                    <>{formatDate(item.value)}</>
                  ) : (
                    <>{item.value}</>
                  )}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default OverViewTab;
